/**
 * Utility functions for directive parsing
 */

/**
 *  Maps the directive keyword with :
 * if => :if
 * for => :for
 * @return {String} Mapped Directive prefixed with colon(:)
 */
const mapDirectiveText = directive => `\:${directive}`;

/**
 * Checks presence of directive in Element
 * @param {HTMLElement} el Dom Element reference
 * @param {String} directive
 * @return {boolean}
 */
export const has = (el, directive) => el.hasAttribute(mapDirectiveText(directive));

/**
 * Extracts value corresponding to directive
 * @param {HTMLElement} el
 * @param {String} directive
 * @return {null|string}
 */
export const getDirValue = (el, directive) => el.getAttribute(mapDirectiveText(directive));

/**
 * Query the elements with directive
 * @param {HTMLElement} el
 * @param {String} directive
 * @return {any[]}
 */
export const queryAll = (el, directive) => Array.from(el.querySelectorAll(`[\\${mapDirectiveText(directive)}]`));

/**
 * Removes the customDirective from element as attribute
 * @param {HTMLElement} el
 * @param {String} directive
 * @return {void|undefined}
 */
export const remove = (el, directive) => el.removeAttribute(mapDirectiveText(directive));

/**
 * Insert text before element
 * @param {HTMLElement} el
 * @param {String} text
 */
export const beforeText = (el, text) => el.insertAdjacentText("beforebegin", text);

/**
 * Insert Text after element
 * @param {HTMLElement} el
 * @param {String} text
 */
export const afterText = (el, text) => el.insertAdjacentText("afterend", text);

/**
 * Wraps element with strings passed as argument before and after
 * @param {HTMLElement} el
 * @param {String} before
 * @param {String} after
 */
export const wrapAround = (el, before, after) => {
    beforeText(el, before);
    afterText(el, after);
};
